import React from 'react';
import { FieldArray } from 'redux-form';
import { connect } from 'react-redux';

import { CHANGED } from 'src/constants/Options';
import ActionButton from 'jbc-front/components/ActionButton';
import { SelectField, RadioField, TextField } from 'jbc-front/components/Form';
import { PlusSquare, Delete } from 'jbc-front/components/icons';
import { isNumber, minValue1, isRequired, maxLength5, maxLength9, maxLength10 } from 'src/utils/CustomValidators';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { RequiredLabel } from 'src/components';
import styles from './InhabitantTaxOfRetirementSection.scss';

const InhabitantTaxOfRetirementItem = ({ remove, residentTaxPayments, formKey }) => (
  <tr>
    <td>
      <SelectField
        noLabel
        name={`${formKey}.clientResidentTaxPaymentId`}
        options={residentTaxPayments}
        validate={isRequired}
      />
    </td>
    <td>
      <TextField
        noLabel
        name={`${formKey}.numberEmployees`}
        maxLength="5"
        validate={[isRequired, isNumber, minValue1, maxLength5]}
      />
    </td>
    <td>
      <TextField
        noLabel
        name={`${formKey}.paymentAmount`}
        yen
        maxLength="10"
        validate={[isRequired, isNumber, minValue1, maxLength10]}
      />
    </td>
    <td>
      <TextField
        noLabel
        name={`${formKey}.cityTaxAmount`}
        yen
        maxLength="9"
        validate={[isRequired, isNumber, minValue1, maxLength9]}
      />
    </td>
    <td>
      <TextField
        noLabel
        name={`${formKey}.prefectureTaxAmount`}
        yen
        maxLength="9"
        validate={[isRequired, isNumber, minValue1, maxLength9]}
      />
    </td>
    <td>
      <RadioField noLabel name={`${formKey}.changed`} options={CHANGED} validate={isRequired} />
    </td>
    <td>
      <ActionButton onClick={remove}>
        <Delete />
      </ActionButton>
    </td>
  </tr>
);

let InhabitantTaxOfRetirements = ({ fields, residentTaxPayments }) => (
  <div className={styles.wrap}>
    <table className={`${styles.table} m-table-list`}>
      <colgroup>
        <col width={200} />
        <col width={110} />
        <col width={128} />
        <col width={128} />
        <col width={128} />
        <col width={131} />
        <col width={50} />
      </colgroup>
      <thead>
        <tr>
          <th>市区町村 {fields.length > 0 && <RequiredLabel />}</th>
          <th>人員 {fields.length > 0 && <RequiredLabel />}</th>
          <th>支払い金額 {fields.length > 0 && <RequiredLabel />}</th>
          <th>市町村民税 {fields.length > 0 && <RequiredLabel />}</th>
          <th>道府県民税 {fields.length > 0 && <RequiredLabel />}</th>
          <th>異動 {fields.length > 0 && <RequiredLabel />}</th>
          <th>削除</th>
        </tr>
      </thead>
      <tbody>
        {residentTaxPayments && residentTaxPayments.length > 0 ? (
          fields.map((item, index) => (
            <InhabitantTaxOfRetirementItem
              key={item}
              formKey={item}
              remove={() => fields.remove(index)}
              residentTaxPayments={residentTaxPayments}
            />
          ))
        ) : (
          <tr>
            <td colSpan={7}>
              <div>
                住民税納付先市区町村の情報がありません。各従業員の住民税を設定して、住民税納付先市区町村を設定してください。
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>

    {residentTaxPayments &&
      residentTaxPayments.length > 0 && (
        <ActionButton icon={<PlusSquare size={11} />} className="u-mt10" onClick={() => fields.push({ changed: '0' })}>
          追加
        </ActionButton>
      )}
  </div>
);

InhabitantTaxOfRetirements = connect(state => ({
  residentTaxPayments: getSelectOptions(state, 'residentTaxPayments')
}))(InhabitantTaxOfRetirements);

const InhabitantTaxOfRetirementSection = () => (
  <FieldArray name="inhabitantTaxRetirements" component={InhabitantTaxOfRetirements} />
);

export default InhabitantTaxOfRetirementSection;
